import { render, staticRenderFns } from "./StepInformacoesGerais.vue?vue&type=template&id=5c01fdce&scoped=true"
import script from "./StepInformacoesGerais.vue?vue&type=script&lang=js"
export * from "./StepInformacoesGerais.vue?vue&type=script&lang=js"
import style0 from "./StepInformacoesGerais.vue?vue&type=style&index=0&id=5c01fdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c01fdce",
  null
  
)

export default component.exports